import { Link, Typography } from "@mui/material";
import { INCENDIUM_WP_PLUGIN_URL } from "features/dataConnectors/utils/woocommerceStoreMeta";

function WooCommercePluginInstructions() {
  return (
    <>
      <Typography variant="body2" color="text.secondary" mb={1.5}>
        Your store is already authorized through Incendium. Install and activate
        the official plugin from the{" "}
        <Link href={INCENDIUM_WP_PLUGIN_URL} target="_blank" rel="noopener">
          WordPress plugin directory
        </Link>
        —no manual setup in WordPress is required.
      </Typography>
      <Typography variant="body2" component="div">
        1. In WordPress admin, go to <strong>Plugins → Add New</strong>, search
        for <strong>Incendium</strong>, and install the plugin (or download it
        from the{" "}
        <Link href={INCENDIUM_WP_PLUGIN_URL} target="_blank" rel="noopener">
          plugin page
        </Link>
        ).
      </Typography>
      <Typography variant="body2" component="div" mt={1}>
        2. <strong>Activate</strong> the plugin.
      </Typography>
      <Typography variant="body2" component="div" mt={1}>
        3. Incendium will connect to your store automatically (usually within a
        few minutes). Use <strong>Refresh status</strong> above to check sooner.
      </Typography>
    </>
  );
}

export default WooCommercePluginInstructions;
